import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useHideAmounts } from '../../contexts/HideAmountsContext';

/**
 * HideAmountsToggle — small eye icon sitting in the dashboard header.
 * One tap hides every tagged amount / percentage / asset name across
 * the app. Choice persists per device.
 *
 * Deliberately keyless (no dropdown, no confirmation) so it can be
 * used mid-Zoom in a single motion.
 */
const HideAmountsToggle = () => {
  const { hideAmounts, toggleHideAmounts } = useHideAmounts();
  const Icon = hideAmounts ? EyeOff : Eye;
  const label = hideAmounts ? 'Amounts hidden — tap to show' : 'Hide amounts on this device';

  return (
    <button
      type="button"
      onClick={toggleHideAmounts}
      title={label}
      aria-label={label}
      aria-pressed={hideAmounts}
      data-testid="hide-amounts-toggle"
      data-hide-amounts-state={hideAmounts ? 'on' : 'off'}
      className={[
        'inline-flex items-center justify-center w-9 h-9 rounded-full transition-colors',
        hideAmounts
          ? 'bg-slate-900 text-white hover:bg-slate-800'
          : 'bg-white text-slate-600 hover:text-emerald-600 hover:bg-emerald-50 border border-slate-200',
      ].join(' ')}
    >
      <Icon className="w-4 h-4" aria-hidden="true" />
    </button>
  );
};

export default HideAmountsToggle;
